import React, { useEffect, useRef, useState } from "react";
import { Grid, CircularProgress } from "@mui/material";
import BreadcrumbComp from "../CommonComponents/Breadcrumb/Breadcrumb";
import Datatable from "../CommonComponents/Datatable/Datatable";
import CaseModal from "./Casemanagementmodal";
import GSTCaseDetailModal from "./Casemanagementdetailmodal";
import { GSTCaseListData } from "../../helpers/renderData";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import { toastAlert } from "../../helpers/toastAlert";
import {
  addCase,
  deleteCase,
  editCase,
  getCases,
  getCaseDetail,
} from "../../services/Casemanagementservices";
import { getApiErrorMessage, getApiFieldErrors, isApiSuccess } from "../../utils/apiErrors";
import { getEmployees } from "../../services/employeeService";
import ConfirmDeleteModal from "../CommonComponents/Confrimationmodal";
import StartFromInquiryCta from "../CommonComponents/StartFromInquiryCta";
import { asCustomerList, getCustomers } from "../../services/customerService";

const CasemanagementList = (props) => {
  const [tableData, setTableData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedCase, setSelectedCase] = useState(null);
  const [editId, setEditId] = useState("");
  const [customerData, setcustomerData] = useState([]);
  const [employeedata, setemployeedata] = useState([])
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [caseRows, setCaseRows] = useState([]);
  const [viewOpen, setViewOpen] = useState(false);
  const [viewCase, setViewCase] = useState(null);
  const openedFromQuery = useRef("");

  const getcustomerList = async () => {
    const data = await getCustomers(props, 1, 100000000);
    setcustomerData(asCustomerList(data));
  };

   const getEmployeeList = async () => {
    const data = await getEmployees(props, 1, 100000000);
    if (data?.data?.employees) {
      setemployeedata(data?.data?.employees);
    }
  };

 const loadData = async (filtered = false) => {
  try {
    setLoading(true); // show loader

    const response = await getCases(
      props,
      currentPage,
      rowsPerPage,
      searchText
    );

    const list = response?.data?.items || [];

    setCaseRows(list);
    const tableResponse = await GSTCaseListData(list, {
      onView: handleView,
      onEdit: handleEdit,
      onDelete: handleDelete,
    });

    setTableData(tableResponse);
    setTotalRows(response?.data?.total || 0);

  } catch (err) {
    toastAlert("Something went wrong while loading cases", "error");
  } finally {
    setLoading(false); // hide loader
  }
};

  const handleSubmit = async (formData) => {
    try {
      const response =
        modalMode === "add"
          ? await addCase(props, formData)
          : await editCase(props, formData, editId);

      if (isApiSuccess(response)) {
        toastAlert(
          response?.data?.message ||
            response?.message ||
            (modalMode === "add" ? "Case added successfully" : "Case updated successfully"),
          "success"
        );
        setShowModal(false);
        loadData(false);
        return { ok: true };
      }

      return {
        ok: false,
        message: getApiErrorMessage(response),
        fieldErrors: getApiFieldErrors(response, {
          customerId: "taxPayerName",
          assignedTo: "assignedTo",
        }),
      };
    } catch (error) {
      return {
        ok: false,
        message: getApiErrorMessage(error, "Something went wrong"),
        fieldErrors: {},
      };
    }
  };

  const handleView = (data) => {
    setViewCase(data);
    setViewOpen(true);
  };

  const handleEdit = (data) => {
    setEditId(data._id);
    setSelectedCase(data);
    setModalMode("edit");
    setShowModal(true);
  };

  const handleAddNew = () => {
    setSelectedCase(null);
    setEditId("");
    setModalMode("add");
    setShowModal(true);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };
  const confirmDelete = async () => {
    try {
      await deleteCase(deleteId, props);
      toastAlert("Case deleted successfully", "success");
      setShowDeleteModal(false);
      setDeleteId("");
      loadData();
    } catch (err) {
      toastAlert("Delete failed", "error");
    }
  };
  const handleFilter = () => {
    if (fromDate && toDate) {
      setIsFiltered(true);
      loadData(true);
    }
  };

  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setIsFiltered(false);
    setSearchText("");
    setCurrentPage(1);
    loadData(false);
  };

  const itemArray = () => [
    {
      name: "GST cases",
      active: true,
      link: "",
    },
  ];

  useEffect(() => {
    loadData();

  }, [currentPage, rowsPerPage, searchText]);
 useEffect(()=>{
      getEmployeeList();
    getcustomerList();
 },[])
  useEffect(() => {
    const openId = new URLSearchParams(props.location?.search || "").get("id");
    if (!openId || openedFromQuery.current === openId) return;
    const found = caseRows.find((row) => String(row._id) === String(openId));
    if (found) {
      openedFromQuery.current = openId;
      handleView(found);
      return;
    }
    (async () => {
      const res = await getCaseDetail({ caseId: openId }, props);
      const record = res?.data || res;
      if (record?._id) {
        openedFromQuery.current = openId;
        handleView(record);
      }
    })();
  }, [caseRows, props.location?.search]);
  return (
    <div>
     <Grid
  container
  alignItems="center"
  justifyContent="space-between"
  style={{ marginBottom: 16 }}
>
  {/* Breadcrumb : Left */}
  <Grid item>
    <BreadcrumbComp items={itemArray()} />
  </Grid>

  <Grid item>
    <StartFromInquiryCta
      history={props.history}
      inquiryType="gst"
      message="Use an inquiry when there is a lead. Walk-in GST cases can be added directly."
      onDirectAdd={handleAddNew}
      directLabel="Add case"
      directPermission="create_casemanagement"
    />
  </Grid>
</Grid>
      {/* DataTable */}
  <Grid container className="data-table-main" mt={1}>
  <Grid item lg={12}>
   <div className="card-main" style={{ width: "100%", padding: 12, position: "relative" }}>
  
  {loading && (
    <div
        style={{
                  position: "absolute",
                  top: "60px",
                  left: "60px",
                  zIndex: 10,
                 }}
    >
      <CircularProgress style={{ color: "#5F5BA8" }} size={35} />
    </div>
  )}

  <Datatable
    props={tableData}
    title="GST cases"
    currentPage={currentPage}
    TotalRow={totalRows}
    rowsPerPage={rowsPerPage}
    onPageChange={(page, rows) => {
      setCurrentPage(page);
      setRowsPerPage(rows);
    }}
    onSearchChange={(search) => {
      setSearchText(search);
      setCurrentPage(1);
    }}
  />

</div>
  </Grid>
</Grid>

      {/* Modal */}
      {viewOpen && (
        <GSTCaseDetailModal
          isOpen={viewOpen}
          onClose={() => {
            setViewOpen(false);
            setViewCase(null);
          }}
          caseData={viewCase}
          props={props}
        />
      )}
      {showModal && (
        <CaseModal
          isOpen={showModal}
          mode={modalMode}
          caseData={selectedCase}
          onClose={() => setShowModal(false)}
          onSubmit={handleSubmit}
          customerData={customerData}
          props={props}
          employeedata={employeedata}
        />
      )}
      <ConfirmDeleteModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete this case?"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(CasemanagementList));
